<kui-content-header [custom]="true"
    [sub]="true"
    class="datetime-bar no-border-top-nested">
    <span class="position-relative">
        <!-- <kui-icon kui-action
            [class.invisible]="!hasPrevDay"
            class="pl-3 pr-3"
            name="chevron-left"
            (click)="selectPreviousDate()"></kui-icon> -->
    </span>
    <div class="flex-stretch d-flex justify-content-center align-items-center"
        *ngIf="dateStart">
        <kui-datetime type="datetime-local"
            (onChange)="doStartDateSelection($event)"
            inputStyle="none"
            format="MMM DD, HH:mm"
            icon="none"
            [date]="dateStart"
            [min]="minDate"
            [max]="maxDate"></kui-datetime>
            
        <kui-icon class="pl-2 pr-2"
            name="arrow-right-long"></kui-icon>

        <kui-datetime type="datetime-local"
            (onChange)="doEndDateSelection($event)"
            inputStyle="none"
            format="MMM DD, HH:mm"
            icon="none"
            [date]="dateEnd"
            [min]="minDate"
            [max]="maxDate"></kui-datetime>
    </div>
    <span class="position-relative">
        <!-- <kui-icon kui-action
            class="pl-3 pr-3"
            [class.invisible]="!hasNextDay"
            name="chevron-right"
            (click)="selectNextDate()"></kui-icon> -->
    </span>
</kui-content-header>